import { get } from 'lodash';

export const getState = (state, param = null, defaultValue = null) => get(state, `agencies${(param ? `.${param}` : '')}`, defaultValue);
